import { Component,Fragment } from 'react';
import { connect } from 'react-redux';
import { ProviderContext, SnackbarKey, withSnackbar } from 'notistack';
import * as notificationActions from '../redux/action/notificationAction';
import { Button } from '@mui/material';
import { store } from '../redux/store';
import { Notification } from '../redux/reducer/notification';

class Notifications extends Component<NotificationPropTypes>
{
	displayed:string[] = [];
	storeDisplayed = (id:string) =>
	{
		this.displayed = [ ...this.displayed, id ];
	};

	shouldComponentUpdate(nextProps:NotificationPropTypes)
	{
        const newNotifications = nextProps.notifications;
		const { notifications: currentNotifications } = this.props;

		let notExists = false;

		for (let i = 0; i < newNotifications.length; i += 1)
		{
			if (notExists) continue;

			notExists = notExists ||
				!currentNotifications.filter(({ id }) => newNotifications[i].id === id).length;
		}
		console.log("是否应该更新",notExists);
		return notExists;
	}

	componentDidUpdate()
	{
		const { notifications = [],enqueueSnackbar,closeSnackbar } = this.props;

		notifications.forEach((notification) =>
		{
			if (this.displayed.includes(notification.id)) return;
			enqueueSnackbar(notification.text,
            {
                variant          : notification.type,
                autoHideDuration : notification.timeout,
                anchorOrigin     : {
                    vertical   : 'top',
                    horizontal : 'center'
                },
                action:(key: SnackbarKey) => (
                    <Fragment>
                        <Button onClick={() => {closeSnackbar(key) }}>
                            知道了
                        </Button>
                    </Fragment>
                )
            });
			this.storeDisplayed(notification.id);
            store.dispatch(notificationActions.removeNotification(notification.id));
		});
	}

	render()
	{
		return null;
	}
}


interface NotificationPropTypes extends ProviderContext{
    notifications:Notification[]
}

const mapStateToProps = (state:any) =>{
	return ({
		notifications : state.notification
	});
}


/**
 * withSnackbar会在props里注入 enqueueSnackbar closeSnackbar
 */
 export default withSnackbar(
	connect(
		mapStateToProps,
		null,
		null,
		{
			areStatesEqual : (next, prev) =>
			{
				const eq = prev.notification === next.notification;
				return eq;
			}
		}
	)(Notifications)
);